"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var IdeationListItem = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IdeationListItem, _Component);

  var _super = _createSuper(IdeationListItem);

  function IdeationListItem() {
    (0, _classCallCheck2.default)(this, IdeationListItem);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(IdeationListItem, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var item = props.item;
      var statusStyle = {
        background: item.bgColor,
        color: item.textColor
      };
      return (0, _preact.h)("tr", {
        className: "ideation-list__table-body-item",
        id: "id-".concat(props.item.id)
      }, (0, _preact.h)("td", {
        className: "ideation-list__table-body-item-status"
      }, (0, _preact.h)("span", {
        style: statusStyle,
        className: "ideation-list__table-body-item-status-name"
      }, item.name), item.default ? (0, _preact.h)("span", {
        className: "ideation-list__table-body-item-status-default"
      }, "Default", (0, _preact.h)(_Tooltip.default, {
        trigger: (0, _preact.h)("i", {
          className: "fa fa-question-circle"
        }),
        tooltipMessage: "Default status will be automatically assigned when a new idea is created"
      })) : null), (0, _preact.h)("td", {
        className: "ideation-list__table-body-item-backgorund"
      }, (0, _preact.h)("div", {
        className: "ideation-list__table-body-item-color-container"
      }, (0, _preact.h)("span", {
        style: {
          backgroundColor: item.bgColor
        },
        className: "ideation-list__table-body-item-color ideation-color-preview"
      }), (0, _preact.h)("span", null, item.bgColor))), (0, _preact.h)("td", {
        className: "ideation-list__table-body-item-text"
      }, (0, _preact.h)("div", {
        className: "ideation-list__table-body-item-color-container"
      }, (0, _preact.h)("span", {
        style: {
          backgroundColor: item.textColor
        },
        className: "ideation-list__table-body-item-color ideation-color-preview"
      }), (0, _preact.h)("span", null, item.textColor))), (0, _preact.h)("td", null, (0, _preact.h)("div", {
        className: "btn btn-default",
        onClick: function onClick() {
          return props.openEditIdeationModal(item, props.idx);
        },
        "data-action": "edit"
      }, "Edit"), !item.default ? (0, _preact.h)("div", {
        className: "btn btn-danger",
        onClick: function onClick() {
          return props.deleteCallback(props.idx);
        },
        "data-action": "delete"
      }, "Delete") : null));
    }
  }]);
  return IdeationListItem;
}(_preact.Component);

var _default = IdeationListItem;
exports.default = _default;